import { render, staticRenderFns } from "./view-skeleton.vue?vue&type=template&id=59172c24&scoped=true"
import script from "./view-skeleton.vue?vue&type=script&lang=js"
export * from "./view-skeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59172c24",
  null
  
)

export default component.exports